import { render } from "./ValidationPage.vue?vue&type=template&id=25f1fb22&scoped=true"
import script from "./ValidationPage.vue?vue&type=script&lang=js"
export * from "./ValidationPage.vue?vue&type=script&lang=js"

import "./ValidationPage.vue?vue&type=style&index=0&id=25f1fb22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f1fb22"]])

export default __exports__